import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from 'react';
import { useTranslation, Language } from '@/utils/translations';

interface FinalDecisionProps {
  question: string;
  decision: string;
  explanation: string;
  onReset: () => void;
}

export const FinalDecision = ({
  question,
  decision,
  explanation,
  onReset,
}: FinalDecisionProps) => {
  const [currentLang, setCurrentLang] = useState<Language>('en');
  
  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLanguage') as Language;
    if (savedLang) {
      setCurrentLang(savedLang);
    }
  }, []);

  const t = useTranslation(currentLang);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex flex-col items-center justify-center min-h-screen p-4"
    >
      <div className="mb-8">
        <h1 className="text-4xl font-semibold text-center text-gray-800">
          {question.endsWith('?') ? question : `${question}?`}
        </h1>
      </div>
      <div className="final-animation mb-8">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0, 1.2, 1] }}
          transition={{ duration: 1 }}
          className="w-full h-full flex items-center justify-center"
        >
          <h1 className="text-6xl font-bold text-white">
            {decision === "yes" ? `${t('yes')}!` : `${t('no')}!`}
          </h1>
        </motion.div>
      </div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1 }}
        className="text-lg text-center max-w-md mb-8 text-gray-700"
      >
        {explanation}
      </motion.p>

      <Button onClick={onReset} className="mt-8">
        {t('makeAnotherDecision')}
      </Button>
    </motion.div>
  );
};